import { createSlice } from '@reduxjs/toolkit';

import { type ILoadAllReviewsResponse, type IReviewsState } from './types';

const initialState: IReviewsState = {
  reviews: undefined,
};

const reviewsSlice = createSlice({
  name: 'Reviews',
  initialState,
  reducers: {
    loadAllReviews: (state): void => {
      state.reviews = undefined;
    },
    loadAllReviewsResponse: (state, action: ILoadAllReviewsResponse): void => {
      state.reviews = action.payload.reviews;
    },
  },
});

export const { loadAllReviews, loadAllReviewsResponse } = reviewsSlice.actions;

export default reviewsSlice.reducer;
